import React from 'react';
import { 
  Settings, 
  FileText, 
  Code, 
  Package, 
  Grid,
  ShoppingCart, 
  Users, 
  BarChart3, 
  Edit,
  X,
  Monitor,
  Layout,
  Video,
  Gift,
  Star,
  Ticket
} from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab, sidebarOpen, setSidebarOpen }) => {
  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: BarChart3
    },
    {
      id: 'basic-info',
      label: 'Basic Information',
      icon: Settings
    },
    {
      id: 'site', // ADD THIS MENU ITEM
      label: 'Site',
      icon: Monitor
    },
    // {
    //   id: 'footer',
    //   label: 'Footer',
    //   icon: Layout
    // },
    {
      id: 'policies',
      label: 'Policies',
      icon: FileText
    },
    {
      id: 'api',
      label: 'API',
      icon: Code
    },
    {
      id: 'products',
      label: 'Products',
      icon: Package
    },
    {
      id: 'categories',
      label: 'Categories',
      icon: Grid
    },
    {
      id: 'orders',
      label: 'Orders',
      icon: ShoppingCart
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: Users
    },
    {
      id: 'ugc-videos',
      label: 'UGC Videos',
      icon: Video
    },
    {
      id: 'offer-management',
      label: 'Offer Management',
      icon: Gift
    },
    {
      id: 'review-management',
      label: 'Review Management',
      icon: Star
    },
    {
      id: 'coupon-management',
      label: 'Coupon Management',
      icon: Ticket
    }
  ];

  return (
    <>
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:relative lg:flex lg:flex-col ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="flex items-center justify-between h-16 px-6 border-b">
          <h1 className="text-xl font-bold text-gray-900">ADMIN PANEL</h1>
          <button
            className="lg:hidden p-1 rounded-md hover:bg-gray-100"
            onClick={() => setSidebarOpen(false)}
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-4">
          <nav className="px-4 space-y-2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  activeTab === item.id
                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <item.icon className="mr-3 h-5 w-5" />
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;